import { FC } from "react";
import { NULL_COMPONENTS_BY_VARIANT } from "../../../../utils/dataTransform/ContentQueryWidget/constants";
import { CardVariantsEnum } from "../../../../utils/dataTransform/ContentQueryWidget/types";

interface CardPlaceHolderProps {
    variant?: CardVariantsEnum;
    classes?: string;
}

const CardPlaceholder: FC<CardPlaceHolderProps> = ({
    classes = "",
    variant = CardVariantsEnum.STANDARD,
}) => {
    const nullComponents = NULL_COMPONENTS_BY_VARIANT[variant];

    return (
        <div
            className={`${classes} placeholder`}
            data-testid="card-cqw-placeholder"
        >
            {nullComponents.imageURL !== null && (
                <div className="card-cqw-head">
                    <div
                        className="card-cqw-image-top"
                        data-testid="card-cqw-image-top"
                    />
                </div>
            )}
            <div className="card-cqw-body">
                <div className="card-cqw-main">
                    <div className="card-cqw-headline" />
                    <div className="card-description " />
                </div>
                <div className="card-cqw-bottom" />
            </div>
        </div>
    );
};

export default CardPlaceholder;
